/**
 * posta.js — scrivere a un paziente dalla sua scheda.
 *
 * PERCHE' NON BASTA `mailto:`
 * Il tasto «Invia email» apriva un `mailto:`, cioe' il programma di posta
 * del sistema operativo. In una clinica dove la posta si legge dal
 * browser quel programma non e' configurato, e il risultato e' il peggiore
 * possibile: il tasto non fa niente e non lo dice. Chi lo preme pensa di
 * aver sbagliato lui.
 *
 * COSA APRE, LO DECIDE LA STRUTTURA
 * Il parametro `posta_web`. Il ripiego e' `mailto`, che e' neutro: un
 * indirizzo di Google scritto qui dentro manderebbe alla posta di
 * qualcun altro le installazioni che usano Outlook.
 *
 * PERCHE' IL VALORE STA NEL BROWSER
 * La finestra si apre dentro il clic. Se il valore lo si andasse a
 * chiedere al server in quel momento, fra il clic e l'apertura ci
 * sarebbe un'attesa, e il browser bloccherebbe la finestra come se fosse
 * pubblicita': i blocchi delle finestre nuove guardano proprio se
 * l'apertura nasce da un gesto della persona o da un'attesa finita dopo.
 * Per questo il valore arriva con l'identita' della struttura, all'avvio,
 * e resta nel browser.
 */

const RICORDO = 'rimedichub_posta_web';

/* Elenco chiuso. Un valore sconosciuto nei parametri non deve costruire
   un indirizzo a caso: ricade su `mailto`, che al peggio non apre niente
   ma non porta da nessuna parte di sbagliato. */
const SERVIZI = {
    gmail:   (a) => `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(a)}`,
    outlook: (a) => `https://outlook.office.com/mail/deeplink/compose?to=${encodeURIComponent(a)}`,
};

/** Tiene da parte il valore letto da /api/struttura. */
export function ricordaPostaWeb(valore) {
    if (typeof valore !== 'string' || !valore.trim()) return;
    try { window.localStorage.setItem(RICORDO, valore.trim().toLowerCase()); }
    catch (e) { /* modalita' privata o spazio finito: si ricade su mailto */ }
}

function scelta() {
    try { return window.localStorage.getItem(RICORDO) || 'mailto'; }
    catch (e) { return 'mailto'; }
}

/**
 * Apre la finestra di composizione con il destinatario gia' scritto.
 *
 * Va chiamata DENTRO il gestore del clic, senza niente in mezzo: vedi
 * sopra il perche'.
 *
 * @param {string} indirizzo  l'email del paziente
 * @returns {boolean} false se non c'era nessun indirizzo
 */
export function apriEmail(indirizzo) {
    const a = String(indirizzo || '').trim();
    if (!a) return false;

    const costruisci = SERVIZI[scelta()];
    if (!costruisci) {
        /* `mailto` non e' una pagina: si assegna alla posizione, altrimenti
           resta una scheda vuota aperta anche quando il programma di posta
           parte. */
        window.location.href = `mailto:${a}`;
        return true;
    }

    /* `noopener` non e' formalita': senza, la pagina che si apre puo'
       toccare quella da cui e' partita, che qui e' una cartella clinica. */
    window.open(costruisci(a), '_blank', 'noopener,noreferrer');
    return true;
}

export default apriEmail;
